'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { teardownBoothPortalSession } from '../lib/booth/booth-portal-teardown';
import { ensureBoothExclusionRules } from '../lib/booth/booth-exclusion-rules';
import { useCreateNewChatTab } from '../components/chat/actions/useCreateNewChatTab';
import { useLayoutStore } from '../store/layoutStore';
import { useTargetId } from '../store/projectStore';

export function useBoothPortalSessionSetup() {
  const tLayout = useTranslations('layout');
  const targetId = useTargetId();
  const { createNewChatTab } = useCreateNewChatTab();

  return useCallback(() => {
    try {
      createNewChatTab({});
    } catch (error: unknown) {
      console.warn('[BoothReset] Failed to start a fresh Copilot chat', {
        error: error instanceof Error ? error : new Error(String(error)),
      });
    }

    const resetMainContentTabsForBoothHandoff =
      useLayoutStore.getState().resetMainContentTabsForBoothHandoff;

    if (targetId) {
      resetMainContentTabsForBoothHandoff({
        id: 'application-overview',
        title: tLayout('home'),
        type: 'application',
      });
      return;
    }

    resetMainContentTabsForBoothHandoff({
      id: 'welcome',
      title: tLayout('welcome'),
      type: 'welcome',
    });
  }, [createNewChatTab, tLayout, targetId]);
}

export function useBoothReset() {
  const setupPortalSession = useBoothPortalSessionSetup();

  return useCallback(async () => {
    ensureBoothExclusionRules();
    await teardownBoothPortalSession();
    setupPortalSession();
  }, [setupPortalSession]);
}
